import moment from "moment";
import queryToUrl from "./queryToUrl";

/** @function
 * @name transposeQuery
 * @ignore
 * @description
 * Transpose query so it can be stored in History (format dates)
 *
 * @param query Object
 * @returns Object
 */
const transposeQuery = (query) => ({
  ...query,
  dates: undefined,
  date_from: query.dates?.start?.format("DD/MM/YYYY"),
  date_to: query.dates?.end?.format("DD/MM/YYYY"),
});

/** @function
 * @name unTransposeQuery
 * @ignore
 * @description
 * Untranspose query object from history. Used by popState
 *
 * @param query Object
 * @returns Object
 */
export const unTransposeQuery = (query) => {
  if (!query) return null;
  const parsed = query ? JSON.parse(query) : {};
  return {
    ...parsed,
    date_from: undefined,
    date_to: undefined,
    dates: {
      start: parsed.date_from ? moment(parsed.date_from, "DD/MM/YYYY") : null,
      end: parsed.date_to ? moment(parsed.date_to, "DD/MM/YYYY") : null,
    },
  };
};

export const getUrlForQuery = (query) => {
  query = transposeQuery(query);
  const qs = queryToUrl(query);
  return qs === "?" ? window.location.pathname : qs;
};

/** @function
 * @name updateUrlForQuery
 * @ignore
 * @description
 * Update the URL and querystring based on the query
 * @param query Object
 * @param replace bool If true, will replace rather than push a new history entry
 */
export default function updateUrlForQuery(query, replace = false) {
  const url = getUrlForQuery(query);
  if (JSON.stringify(query) !== window.history.state) {
    if (replace) {
      window.history.replaceState(JSON.stringify(query), "", url);
    } else {
      window.history.pushState(JSON.stringify(query), "", url);
    }
  }
}
